<template>
  <div class="popUpWrap">
    <section class="popup dark assessment">
      <div class="topArea">
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <h5>{{ t("skillCertify-assessment-duration-guide") }}</h5>
        <p>{{ t("skillCertify-assessment-duration-description-1") }}</p>
        <div class="boxArea" style="margin-top: 12px; color: #B6882F;padding: 13.5px;">
          {{ t('skillCertify-assessment-duration-description-2', {hour: dialogStore.options.props.hour, minute: dialogStore.options.props.min}) }}
        </div>
        <div class="btnArea">
          <button @click.stop="onClickConfirm">{{ t("common-ok") }}</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {useDialogStore} from "~/store/dialog/dialogStore";
import {useI18n} from "#imports";

const { t } = useI18n();

const dialogStore = useDialogStore();

const onClickConfirm = () => {
  dialogStore.options.confirm?.event();
  dialogStore.close();
}

const onClickClose = () => {
  dialogStore.options.close?.event();
  dialogStore.close();
}
</script>

